import styled from 'styled-components';

export const StyledContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
`;

export const StyledCountText = styled.p`
  font-weight: bold;
  font-size: 14px;
  margin: 0;
  span {
    font-size: 18px;
    color: #6200ea;
  }
`;
